/**
 * UUID生成器
 *
 * @export
 * @class UUID
 */
export default class UUID {
  static create() {
    return (UUID.S4() + UUID.S4() + '-' + UUID.S4() + '-' + UUID.S4() + '-' + UUID.S4() + '-' + UUID.S4() + UUID.S4() + UUID.S4());
  }

  static S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
}
